function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { context } from "../../../components/wr-context";
import request from "../../../utils/request";
export var generateDocumentFile = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(param) {
        var exportOptions, html, _returnType, returnType, type, blob;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    exportOptions = param.exportOptions, html = param.html, _returnType = param.returnType, returnType = _returnType === void 0 ? "blob" : _returnType;
                    type = exportOptions.type;
                    _ctx.next = 4;
                    return request({
                        url: "".concat(context.constants.appHost, "/api/v1/documents/export?format=").concat(type),
                        method: "POST",
                        body: JSON.stringify({
                            data: {
                                html: html
                            }
                        })
                    });
                case 4:
                    blob = _ctx.sent;
                    blob = blob.slice(0, blob.size, "application/pdf");
                    if (!(returnType === "blob")) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", blob);
                case 8:
                    _ctx.t0 = Buffer;
                    _ctx.next = 11;
                    return blob.arrayBuffer();
                case 11:
                    _ctx.t1 = _ctx.sent;
                    return _ctx.abrupt("return", _ctx.t0.from.call(_ctx.t0, _ctx.t1).toString("base64"));
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function generateDocumentFile(_) {
        return _ref.apply(this, arguments);
    };
}();
